import { render, staticRenderFns } from "./shopOrderDetail.vue?vue&type=template&id=30ab50a2&scoped=true&"
import script from "./shopOrderDetail.vue?vue&type=script&lang=js&"
export * from "./shopOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopOrderDetail.vue?vue&type=style&index=0&id=30ab50a2&prod&lang=less&scoped=true&"
import style1 from "./shopOrderDetail.vue?vue&type=style&index=1&id=30ab50a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab50a2",
  null
  
)

export default component.exports